export class UserPresence {
  constructor(
    readonly id: string,
    readonly status: 'online' | 'offline' | 'break',
  ) {}
}
